import { render, staticRenderFns } from "./secret-sync-rule.vue?vue&type=template&id=46a477d8&scoped=true&"
import script from "./secret-sync-rule.vue?vue&type=script&lang=js&"
export * from "./secret-sync-rule.vue?vue&type=script&lang=js&"
import style0 from "./secret-sync-rule.vue?vue&type=style&index=0&id=46a477d8&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a477d8",
  null
  
)

export default component.exports